import { emailFooterLooksLikeHtml } from '../../utils/editPage'

export function EmailFooterPreviewContent({ value }: { value: string }) {
  const v = value ?? ''
  if (!v.trim()) {
    return <p className="px-3 py-2 text-sm text-slate-400">(Empty)</p>
  }
  if (emailFooterLooksLikeHtml(v)) {
    return (
      <div
        className="min-h-[220px] w-full max-w-full overflow-auto px-3 py-2 text-left text-sm leading-relaxed text-slate-900 [word-break:break-word] [&_a]:text-sky-700 [&_a]:underline"
        dangerouslySetInnerHTML={{ __html: v }}
      />
    )
  }
  return (
    <div className="min-h-[220px] w-full max-w-full overflow-auto px-3 py-2 text-left font-sans text-sm leading-relaxed text-slate-900 whitespace-pre-wrap [word-break:break-word]">
      {v}
    </div>
  )
}
